const styles = {
  autocomplete: {
    "& .MuiInputBase-sizeSmall.MuiOutlinedInput-root": {
      height: 45,
      overflow: "hidden",
    },
  },
};
export default styles;
